import type { League } from '../core/league/league';
import type { CountryCode } from '../core/model/countries';
import type { Division, Game, Player, PointsByDate } from '../core/model/types';
import type { AppState } from '../core/sync/syncEngine';

// What the tabs show: the four data sets, once all of them are loaded.
export interface AppData {
    // What the league's data has: LEAGUE_FEATURES[league].
    league: League;
    country: CountryCode;
    players: Player[];
    points: PointsByDate;
    scores: Game[];
    standings: Division[];
}

export function selectAppData(state: AppState, league: League): AppData | undefined {
    const { players, points, scores, standings } = state;
    if (players.value === undefined || points.value === undefined
        || scores.value === undefined || standings.value === undefined) {
        return undefined;
    }
    return {
        league,
        country: state.country as CountryCode,
        players: players.value,
        points: points.value,
        scores: scores.value,
        standings: standings.value,
    };
}
